import { LibraryDiscipline } from './library-discipline.model'
import { Privileged } from '@app/core/class/privileged.class'
import { RatecardVersion } from '@app/features/scope-overview/model/ratecard-version.model'
import { Type } from 'class-transformer'

export class LibraryEntry extends Privileged {
  discipline: Partial<LibraryDiscipline>
  @Type(() => RatecardVersion) rateCardVersion: RatecardVersion
}
